/**
 * Qatari riyal.
 */
export var QAR = {
  code: 'QAR',
  base: 10,
  exponent: 2
};